import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function AreaGroup(props) {
    const { t } = useTranslation("translation");
    return props.isMultipleAreaGroup ? (
        <Autocomplete
            multiple
            id="area_group_filter_id"
            options={props.areaData}
            limitTags={5}
            value={props.areaData.filter((item) => props.selectedAreaFilter?.includes(item.id))}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            onChange={(event, newValue) => {
                props.HandleAreaFilterChange(newValue);
            }}
            renderOption={(_props, option) => <li {..._props}>{option.name}</li>}
            renderInput={(params) => <TextField id="or_TextField_2" {...params} margin="normal" label={t("Area")} variant="outlined" />}
            size={props.size ?? "normal"}
        />
    ) : (
        <Autocomplete
            id="area_group_filter_id"
            onChange={(event, newValue) => {
                props.HandleAreaFilterChange(newValue);
            }}
            value={!props.selectedAreaFilter || props.selectedAreaFilter === "null" ? null : props.selectedAreaFilter}
            defaultValue=""
            options={props.areaData.map((option) => option.name)}
            renderInput={(params) => <TextField id="bl_table_TextField_6" {...params} margin="normal" label={t("Area")} variant="outlined" error={props.error ? props.error.areaGroupText.length > 0 : false}
            helperText={props.error ? props.error.areaGroupText : ""} />}
            size={props.size ?? "normal"}
        />
    );
}
